import { LabelSummary } from 'rwl-shared/dist/models';
import { Label } from './Label';
import styled from 'styled-components6';
import { deduplicateLabelsByName } from 'rwl-shared/dist/utils/label';

const LabelsContainer = styled.div`
    overflow: hidden;
    height: calc(18px + var(--rwl-spacing-sm));
    margin-top: var(--rwl-spacing-sm);
`;

type LabelListProps = {
    labels?: LabelSummary[];
};

export const LabelList = ({ labels }: LabelListProps): JSX.Element | null => {
    if (!labels) {
        return null;
    }

    const allLabelsLength = labels.length;
    let labelsToRender = deduplicateLabelsByName(labels);
    if (allLabelsLength > 3) {
        labelsToRender = labels.slice(0, 3);
    }
    return (
        <LabelsContainer>
            {labelsToRender.map((label, index) => (
                <Label key={index} name={label.name} />
            ))}
            {allLabelsLength > 3 && <Label name={`+${allLabelsLength - 3}`} />}
        </LabelsContainer>
    );
};
